module.exports = __webpack_public_path__ + "front/img/beian_icon.1b78b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beian_icon.png
// module id = PeF9
// module chunks = 12